import Carousel from "../../Carousel";

const LeadershipHero = ({ head, subhead1, subhead2, carouselQuotes }) => (
  <section className="hero-leadership full mb-0">
    <div className="hero-leadership__banner banner">
      <div className="hero-leadership__copy-cta">
        <div className="hero-leadership__copy">
          <div className="section-header">
            <h1 className="heading heading--xxl">{head}</h1>
          </div>
          <h6 className="heading--xxs">{subhead1}</h6>
          <h6 className="heading--xxs">{subhead2}</h6>
        </div>
      </div>
      <Carousel svgSrc="leadership" quotes={{ ...carouselQuotes }} />
    </div>
  </section>
);

export default LeadershipHero;
